export default {

	async page_list () {

		const list = await Anvil.models.CompanyTagList.fetch()

		await Anvil.renderPage('/company_tag/page_list', { list })
	},

	async action_refresh () {

		const list = await Anvil.models.CompanyTagList.fetch()

		Anvil.page.list = list
		Anvil.models.components.Grid.find('#company_tag_grid').list = list
	},

	async modal_edit (id) {

		const tag = await Anvil.models.CompanyTag.fetch(id)

		await Anvil.modal('/company_tag/modal_edit', { tag })
	},

	async action_save (tag) {

		// Tell the record to commit
		await tag.record.commit()

		Anvil.toast.success('Elmentve', 'A címke mentése sikeres')

		// Refresh list
		await this.action_refresh()

		// Focus on tag
		let grid = Anvil.models.components.Grid.find('#company_tag_grid')
		grid.select(grid.list.getById(tag.id), true)

		return true
	},

	async action_delete (id, confirm = false) {

		// Megerősítés kérése
		if (!confirm) {
			Anvil.confirm({
				title: 'Törlés megerősítése',
				message: '<p>Valóban törölni szeretné a kijelölt címkét?<br/>A felcímkézett cégekről eltávolításra kerül.</p>',
				btn_ok: '<i class="fas fa-trash me-2"></i>Törlés',
				btn_ok_class: 'danger',
				btn_cancel: '<i class="fas fa-times me-2"></i>Mégsem',
				onclose: (confirmed) => {
					if (confirmed) {
						Anvil.exec('company_tag/action_delete', id, true)
					}
				}
			})
			return
		}

		console.log('delete')
		await Anvil.models.CompanyTag.delete(id)

		Anvil.toast.success('Törölve', 'A címke törlése sikeres')

		// Refresh list
		await this.action_refresh()
	}

}
